// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ttlMFN09X70SOfavOkRj{margin-top:-2.1875rem}`, "",{"version":3,"sources":["webpack://./services/common/src/components/Popover/styles.module.scss"],"names":[],"mappings":"AAEA,sBACE,qBAAA","sourcesContent":["@import '../../styles/mixins.scss';\n\n.popover {\n  margin-top: pixel2rem(-35);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `ttlMFN09X70SOfavOkRj`
};
export default ___CSS_LOADER_EXPORT___;
